/**
 * Created by Fitz on 2017-06-20 09:53
 */
import { saveAs } from 'file-saver'
// import XLSX from 'xlsx'
import XLSX from 'xlsx-js-style'

const ExportUtil = {
  /**
   * 导出数据
   * @param info --> 需要导出的数据(Array类型)，例如[{id:1,name:'aa'},{id:2,name:'bb'}]
   * @param filename --> 导出的文件名字
   * @param tableHeader  ---> 导出的数据的表头，以上面的数据为例子，则tableHeader为[{id:'编号'}，{name:'名字'}]，刚导出的xml文件就会出现编号，名字列，顺序按照该tableHeader数组元素顺序排列
   *  如果要用到日期（一般是动态从后台返回的，个数不定）表头可以这样写[{'2017-2-10':'2017-2-10'}]
   * @param type 类型 默认xlsx
   * @returns {boolean}
   */
  downloadExl (info, filename, tableHeader = [], type) {
    if (info === undefined || !info.length) return false
    if (filename === undefined) filename = '报表'
    const keyArr = []
    const keyObj = {}
    // 将tableHeader转化成一个对象
    tableHeader.forEach((v) => {
      keyArr.push(Object.keys(v)[0])
      Object.assign(keyObj, keyObj, v)
    })
    info.unshift(keyObj)
    // 用来保存转换好的info
    let header = []

    // 第一个外层map处理完后是[ [{ v: '姓名'， position: 'A1' }, { v: '10'， position: 'B2' }], [...] ]的格式
    // 然后再经过下一个reduce将里面的数据合并成一个大数组[{}, {}, {}]
    // 后面的foreach方法将里面的数组转化成对象{ A1: { v: 10 }, B1: { v:12 }}的格式
    info.map((v, i) => keyArr.map((k, j) => Object.assign({}, {
      v: (v[k] === undefined || v[k] === null) ? '' : v[k] ,
      position: (j > 25 ? this.getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1)
    }))).reduce((prev, next) => prev.concat(next)).forEach((v) => header[v.position] = {
      v: v.v,
      s: {
        // 设置文字居中
        alignment: {
          horizontal: "center" ,
          vertical: "center"
        }
      }
    })
    let outputPos = Object.keys(header) // 设置区域,比如表格从A1到D10
    let tmpWB = {
      SheetNames: ['reports'], // 保存的表标题
      Sheets: {
        'reports': Object.assign({}, header, // 内容
          {
            '!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1] // 设置填充区域
          })
      }
    }
    let tmpDown = new Blob([this.s2ab(XLSX.write(tmpWB, {
      bookType: (type === undefined ? 'xlsx' : type),
      bookSST: false,
      type: 'binary'
    } // 这里的数据是用来定义导出的格式类型
    ))], {
      type: 'application/octet-stream;charset=utf-8'
    }) // 创建二进制对象写入转换好的字节流
    console.log(saveAs)
    saveAs(tmpDown, filename + '.xlsx')
  },

    /**
     * 导出数据,需要去头信息里的type字段
     * @param info --> 需要导出的数据(Array类型)，例如[{id:1,name:'aa'},{id:2,name:'bb'}]
     * @param filename --> 导出的文件名字
     * @param tableHeader  ---> 导出的数据的表头，以上面的数据为例子，则tableHeader为[{id:'编号'}，{name:'名字'}]，刚导出的xml文件就会出现编号，名字列，顺序按照该tableHeader数组元素顺序排列
     *  如果要用到日期（一般是动态从后台返回的，个数不定）表头可以这样写[{'2017-2-10':'2017-2-10'}]
     * @param type 类型 默认xlsx
     * @returns {boolean}
     */
    downloadExcel1(info, filename, tableHeader = [], type) {
        let tableHeader1 = []
      tableHeader.forEach(item => {
          tableHeader1.push({[item.field]: item.desc})
      })
      this.downloadExl(info, filename, tableHeader1, type)
    },

  /**
   * 多级表头的导出
   * exportDataTest()给出了导出样例
   * @param info
   * [
   *  {id: 10, name: 'zz', math: 10, english: 11, game1: 1000, game2: 1001},
   *  {id: 11, name: 'zb', math: 11, english: 12, game1: 1000, game2: 1001},
   *  {id: 12, name: 'zc', math: 12, english: 13, game1: 1000, game2: 1001}
   * ]
   * @param filename 文件名
   * @param tableHeader 例如二级表头，一个数组里需要两个数组 [[], []]，而最后一个数组是最详细的，header结构如下，id, 名称，科目，游戏会进行合并
   * [{id: 'id'}, {name:'名称'}, {score:'科目'}, {score: '科目'}, {game: '游戏'}, {game: '游戏'}],
   * [{id: 'id'}, {name:'名称'}, {math:'数学'}, {english: '英语'}, {game1: '弹球'}, {game2: '卡丁车'}],
   * @param type
   * @returns {boolean}
   */
  downloadComplexExl (info, filename, tableHeader = [], type) {
    if (info === undefined || !info.length) return false
    if (filename === undefined || filename === '') filename = '报表'

    // 1.先通过tableHeader的长度来判断是几级表头
    const headerLength = tableHeader.length

    const allHeaders = []
    const headerInfo = []
    tableHeader.forEach(item => {
      const arr = []
      const obj = {}
      item.forEach((e) => {
        arr.push(Object.keys(e)[0])
        Object.assign(obj, obj, e)
      })
      allHeaders.push(arr)
      headerInfo.push(obj)
    })

    // allHeaders= [[], []]
    // [["id", "name", "score", "score"]
    // ["id", "name", "math", "english"]]

    // 接下来，计算表头合并的坐标
    // 先从行开始计算
    const allMerges = {}
    allHeaders.forEach((item, index) => {

      item.forEach((e, j) => {
        if ({}.hasOwnProperty.call(allMerges, e)) {
          allMerges[e]['e'] = {
            r: index,
            c: j
          }
        } else {
          allMerges[e] = {}
          allMerges[e]['s'] = {
            r: index,
            c: j
          }
          allMerges[e]['e'] = {
            r: index,
            c: j
          }
        }
      })

    })

    const values = Object.values(allMerges)

    // 表头
    // {id: "id", name: "名称", score: "科目"}
    // {id: "id", name: "名称", math: "数学", english: "英语"}
    headerInfo.push(...info)

    const all = {}

    // 计算每一个值的位置
    // 第一个外层map处理完后是[ [{ v: '姓名'， position: 'A1' }, { v: '10'， position: 'B2' }], [...] ]的格式
    // 然后再经过下一个reduce将里面的数据合并成一个大数组[{}, {}, {}]
    // 后面的foreach方法将里面的数组转化成对象{ A1: { v: 10 }, B1: { v:12 }}的格式
    headerInfo.map((v, i) => {
      let keyArr
      if (i < headerLength) {
        keyArr = allHeaders[i]
      } else {
        keyArr = allHeaders[headerLength -1]
      }
      return keyArr.map((k, j) => {
        return Object.assign({}, {
          v: v[k] !== 0 && !v[k] ? '' : v[k],
          position: (j > 25 ? this.getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1)
        })
      })
    }).reduce((prev, next) => prev.concat(next)).forEach((v) => all[v.position] = {
      v: v.v,
      s: {
        // 设置文字居中
        alignment: {
          horizontal: "center",
          vertical: "center"
        }
      }
    })

    let outputPos = Object.keys(all) // 设置区域,比如表格从A1到D10
    let tmpWB = {
      SheetNames: ['reports'], // 保存的表标题
      Sheets: {
        'reports': Object.assign({}, all, // 内容
          {
            '!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1], // 设置填充区域
            '!merges': values
          })
      }
    }
    let tmpDown = new Blob([this.s2ab(XLSX.write(tmpWB, {
      bookType: (type === undefined ? 'xlsx' : type),
      bookSST: false,
      type: 'binary',
    } // 这里的数据是用来定义导出的格式类型
    ))], {
      type: 'application/octet-stream;charset=utf-8'
    }) // 创建二进制对象写入转换好的字节流
    saveAs(tmpDown, filename + '.xlsx')
  },

  /**
   * 导出测试用例
   */
  exportDataTest() {
    // 表头数据结构，最后一个数组里的key要和数据里(dataInfo)的结构对应上
    const header1 = [
      [{id: 'id'}, {name:'名称'}, {score:'科目'}, {score: '科目'}, {game: '游戏'}, {game: '游戏'}],
      [{id: 'id'}, {name:'名称'}, {math:'数学'}, {english: '英语'}, {game1: '弹球'}, {game2: '卡丁车'}],
    ]
    // 数据
    const dataInfo = [
      {id: 10, name: 'zz', math: 10, english: 11, game1: 1000, game2: 1001},
      {id: 11, name: 'zb', math: 11, english: 12, game1: 1000, game2: 1001},
      {id: 12, name: 'zc', math: 12, english: 13, game1: 1000, game2: 1001}
    ]
    this.downloadComplexExl(dataInfo, '', header1)
  },
  // 字符串转字符流
  s2ab (s) {
    let buf = new ArrayBuffer(s.length)
    let view = new Uint8Array(buf)
    for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
    return buf
  },
// 将指定的自然数转换为26进制表示。映射关系：[0-25] -> [A-Z]。
  getCharCol (n) {
    let s = '', m = 0
    while (n > 0) {
      m = n % 26 + 1
      s = String.fromCharCode(m + 64) + s
      n = (n - m) / 26
    }
    return s
  },
  /**
   * 获取最长的项的index
   * @param info
   */
  getLongestCol (info) {
    if (info === undefined || info.length === 0) {
      return 0
    }
    let index = 0
    let len = 0
    info.forEach((el, k) => {
      if (Object.keys(el).length > len) {
        len = Object.keys(el).length
        index = k
      }
    })
    return index
  }
}

export default ExportUtil
